export const ACTIONS_PREFIX = 'Map';
